<template>
  <v-content>
    <v-container
      class="pl-0 mt-2"
      fluid
    >
      <pageTitle>
        Messages
      </pageTitle>
      <v-list three-line dense class="pt-0">
        <v-divider></v-divider>
        <v-list-item-group
          v-model="selectedRoom"
          active-class="selectedRoom"
        >
          <template
            v-for="(room, index) in rooms"
          >
            <roomListItem
              :key="`r${room.rid}`"
              :item="room"
              @click="showChatRoom"
            ></roomListItem>
            <v-divider
              :key="index"
            >
            </v-divider>
          </template>
        </v-list-item-group>
      </v-list>

    </v-container>
    <bottomNavigation
      activeNav="inbox"
    ></bottomNavigation>
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import RoomListItem from '@/components/Like/RoomListItem'
import BottomNavigation from '@/components/Like/BottomNavigation'
import pageTitle from '@/components/Like/PageTitle'
import service from '@/plugins/service'

export default {
  components: {
    RoomListItem,
    BottomNavigation,
    pageTitle,
  },
  data: () => ({
    selectedRoom: '',
    rooms: [],
    roomsSnapshot: () => ({}),
    support: {
      uid: '',
      photoUrl: '',
      nickname: '',
    }
  }),
  async mounted() {
    // ログインチェック
    let user = {}
    try {
      user = await service.authCheck()
    } catch (e) {
      this.$router.replace('/signIn/inbox')
      return
    }
    // Profile完成確認
    const isProfileComplete = await service.isProfileComplete(user.uid)
    if (!isProfileComplete) {
      this.setNextRoute(`/inbox`)
      this.$router.replace('/myProfile')
      return
    }
    // Paikeout Supportの情報を取得
    this.support = await service.getPaikeoutSupportInfo()
    const self = this
    const db = firebase.firestore()
    this.rooms.snapshot = db.collection('rooms')
      .where('uids', 'array-contains', user.uid)
      .orderBy('modified', 'desc')
      .onSnapshot(async (snapshot) => {
        let existsSupport = false
        const rooms = []
        snapshot.forEach((roomDoc) => {
          const room = {}
          // room info
          room.rid = roomDoc.id
          const roomData = roomDoc.data()
          if (roomData.deleteFlag === true) {
            // Blockされている人は表示しない
            return
          }
          room.latestComment = roomData.latestComment
          room.modified = roomData.modified
          // user info
          roomData.uids.forEach((uid) => {
            if (uid != user.uid) {
              // 相手のuidをroomにセット
              room.uid = uid
            }
          })
          if (room.uid) {
            if (room.uid == self.support.uid) {
              // Supportは先頭に入れる
              existsSupport = true
              rooms.unshift(room)
            } else {
              rooms.push(room)
            }
          }
        })
        if (!existsSupport) {
          rooms.unshift(self.support)
        }
        const roomsInfo = await service.getRoomInfos(user.uid, rooms)
        self.rooms.splice(0)
        rooms.forEach(room => {
          const work = roomsInfo[room.uid]
          room.nickname = work.nickname
          room.photoUrl = work.photoUrl
          room.isReaded = !work.hasUnread
          self.rooms.push(room)
        })
    })
  },
  methods: {
    ...mapActions('storage', [
      'setNextRoute',
    ]),
    showChatRoom(props) {
      if (props.rid) {
        this.$router.push(`/room/${props.rid}`)
      } else {
        // ridが無いときは、多分PaikeoutSupportへ
        this.$router.push(`/paikeout/${props.uid}`)
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    try {
      this.roomsSnapshot()
    } catch (e) {
      service.log('rooms snapshot terminate failed.')
      service.log(e)
    } finally {
      next()
    }
  },
}

</script>
